import React, { useId } from 'react';
import './Input.css';

const Input = ({ 
  type = 'text',
  name,
  placeholder = '',
  value,
  onChange,
  onBlur,
  error = '',
  disabled = false,
  required = false,
  className = '',
  multiline = false,
  rows = 3,
  label,
  id,
  ...props 
}) => {
  const generatedId = useId();
  const inputId = id || generatedId;

  const inputClass = [
    'input',
    error ? 'input-error' : '',
    disabled ? 'input-disabled' : '',
    className
  ].filter(Boolean).join(' ');

  const InputElement = multiline ? 'textarea' : 'input';
  const inputProps = {
    id: inputId,
    name,
    placeholder,
    value,
    onChange,
    onBlur,
    disabled,
    required,
    className: inputClass,
    ...(multiline && rows && { rows }),
    ...props
  };

  return (
    <div className="input-container">
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
          {required && <span className="input-label-required"> *</span>}
        </label>
      )}
      {InputElement === 'textarea' ? (
        <textarea {...inputProps} />
      ) : (
        <input type={type} {...inputProps} />
      )}
      {error && (
        <span className="input-error-message" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default Input;
